const CONFERENCIA_CUSTODIANTE_STATUS = {
  OK: { id: "OK", descricao: "OK", color: "success" },
  AUS: { id: "AUS", descricao: "Ausente", color: "error" },
  DIV: { id: "DIV", descricao: "Divergente", color: "warn" },
};

export default CONFERENCIA_CUSTODIANTE_STATUS;
